export const selectOperacoes = (state) => state.programa.operacoes;

export const selectEstagios = (state) => state.programa.estagios;

export const selectProgramas = (state) => state.programa.programas;

export const selectAreas = (state) => state.programa.areas;
